import React from "react";
import classNames from "classnames";
import { Card } from "@design-system/Card/Card";
import styles from "./TablePageSubHeader.module.scss";

interface TablePageSubHeaderProps {
    children: React.ReactNode;
    className?: string;
    borderBottom?: boolean;
}

/**
 * A thin status strip between the main page header and the filter
 * toolbar. Height matches the GridTable column-header row so the bottom
 * edge bottom-aligns with the adjacent tasks-list column header when
 * this is rendered inside a task body opened next to the tasks list.
 *
 * Generic by design — pass any node as children (e.g. "Confirmed 3 of
 * 12", "Categorizing 5 of 225", a <Loader /> while counts load, etc.).
 *
 * Uses the same <Card> wrapper as TablePageHeader for folder
 * consistency; `noBorder` strips Card's default 1px border (opt-in via
 * `borderBottom`) and `sharpEdges` disables the default border-radius
 * since this is a flush strip inside a panel rather than a free-floating
 * card.
 */
export const TablePageSubHeader: React.FC<TablePageSubHeaderProps> = ({
    children,
    className,
    borderBottom,
}) => (
    <Card
        noBorder
        sharpEdges
        className={classNames(
            styles.container,
            { [styles.borderBottom]: borderBottom },
            className,
        )}
    >
        {children}
    </Card>
);
